import { useState, useEffect } from 'react';
import { toast } from 'react-toastify';
import { fetchSensorAlert } from '../../../api/sensorApi';


const useSensorAlerts = (sensorID, start, end, alertThresholdUpdate) => {
    const [alertReport, setAlertReport] = useState(null);
    const [loading, setLoading] = useState(false);

    useEffect(() => {
        if (!sensorID || !start || !end) return;

        setLoading(true);
        fetchSensorAlert(sensorID, start, end)
            .then((data) => {
                setAlertReport(data);
                setLoading(false);
            })
            .catch((error) => {
                console.error(error);
                setLoading(false);
                toast.error("Error fetching alerts");
            });
    }, [sensorID, start, end, alertThresholdUpdate]);

    return { alertReport, loading, setAlertReport, setLoading };
};

export default useSensorAlerts;